import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cs-table',
  templateUrl: 'cs-table.html',
  host: { 'class': 'table' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsTable {}
